import {
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
  Box,
  Button,
  TextField,
  Alert,
  Card,
  CardContent,
} from "@mui/material";
import { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import InfoIcon from "@mui/icons-material/Info";
import SearchIcon from "@mui/icons-material/Search";
import { useDispatch, useSelector } from "react-redux";
import useAlert from "../hooks/useAlert";

import {
  deleteCategoryVaiant,
  getCategoryVaiant,
} from "../redux/actions/categorysActions";
import CategoryVariantAdd from "./UI/reusable-components/CategoryVariantComponents/AddCategoryVariant";

export const CategoryVariant = () => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState(data);
  const [searchVisible, setSearchVisible] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const dispatch = useDispatch();

  const authUserId = useSelector((state) => state?.auth?.user?.id);
  const token = useSelector((state) => state?.auth?.user?.accessToken?.token);

  const handleSearchToggle = () => {
    setSearchVisible((prev) => !prev);
    setSearchTerm("");
    setFilteredData(data);
  };

  useEffect(() => {
    setFilteredData(data);
  }, [data]);

  const handleSearchChange = (event) => {
    const term = event.target.value.toLowerCase();
    setSearchTerm(term);
    const filtered = data.filter((item) =>
      item.name.toLowerCase().includes(term)
    );
    setFilteredData(filtered);
  };

  const [openModal, setOpenModal] = useState(false);

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);
  const {
    showSuccessAlertCategoryVariantDelete,
    showErrorAlertCategoryVariantDelete,
  } = useAlert();
  const deleteCategoryVariant = async (id) => {
    const confirmDelete = window.confirm(
      "Bu eşleştirmeyi silmek istediğinizden emin misiniz?"
    );

    if (confirmDelete) {
      try {
        const response = await dispatch(deleteCategoryVaiant(id, token));

        if (response.status) {
          showSuccessAlertCategoryVariantDelete();
          dispatch(getCategoryVaiant(authUserId, token));
        }
        return response;
      } catch (error) {
        showErrorAlertCategoryVariantDelete();
        console.error("Error deleting address:", error);
      }
    }
  };

  useEffect(() => {
    if (authUserId) {
      dispatch(getCategoryVaiant(authUserId, token));
    }
  }, []);

  const categoryVariants = useSelector((state) => state?.categoryVariant);

  useEffect(() => {
    setData(categoryVariants?.categoryVariant);
  }, [categoryVariants]);

  return (
    <Box sx={{ width: "100%", padding: { xs: 1, sm: 2, md: 3 } }}>
      <Alert
        sx={{ mb: 2, fontSize: { xs: "0.875rem", sm: "1rem" } }}
        severity="info"
        icon={<InfoIcon />}
      >
        <strong>Bilgi:</strong> Kategori varyant eşleştirmeleri, XML verilerindeki varyant değerlerinin ilgili pazaryeri kategorilerindeki karşılıklarıyla doğru şekilde eşleştirilmesini sağlar. İşlem öncesinde aşağıdaki sıraya uyulması önerilir.
      </Alert>

      <Card
        sx={{
          mb: 3,
          backgroundColor: "#E3F2FD",
          borderLeft: "4px solid #2196F3",
        }}
      >
        <CardContent>
          <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
            <InfoIcon sx={{ mr: 1, color: "#2196F3" }} />
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              Kategori Varyant Eşleştirmesi Nasıl Yapılır?
            </Typography>
          </Box>
          <Typography variant="body2" sx={{ ml: 4, color: "#424242" }}>
            XML kaynağından gelen varyant değerleri (örneğin beden, numara vb.) her pazaryerinde farklı kategori alanlarına karşılık gelebilir. Aynı &quot;beden&quot; verisi N11 tarafında &quot;numara&quot;, Hepsiburada tarafında ise &quot;ayakkabı numarası&quot; alanına denk gelebilir. Bu nedenle eşleştirme işleminde aşağıdaki sıranın izlenmesi gerekmektedir:
            <br />
            <br />
            <strong>İşlem sırası:</strong>
            <br />
            • <strong>1. Pazaryeri seçimi:</strong> Öncelikle ürünün gönderileceği pazaryeri seçilmelidir.
            <br />
            • <strong>2. Sistem varyant değeri:</strong> Ardından sistemde tanımlı ve XML’den gelen varyant değeri (ör. Beden, Renk) seçilmelidir.
            <br />
            • <strong>3. Ürün kategorisi:</strong> Ürünün hangi kategoride listeleneceği belirlenmelidir.
            <br />
            • <strong>4. Pazaryeri kategorisi:</strong> Seçilen pazaryerine ait ilgili kategori seçilmelidir.
            <br />
            • <strong>5. Pazaryeri varyant değeri:</strong> Son adımda, ilgili pazaryeri kategorisindeki varyantlar arasından gönderimde kullanılacak varyant değeri seçilmelidir.
            <br />
            <br />
            <strong>Örnek uygulama:</strong> Trendyol pazaryeri seçildikten sonra, hata veren veya uyumsuz gelen varyant değeri olarak sistemde &quot;Beden&quot; seçilmiş ve &quot;Ayakkabı&quot; kategorisi belirlenmiştir. Ardından Trendyol kategorilerinden ilgili ayakkabı kategorisi seçilerek, bu kategorideki varyantlar arasından ürünün gönderileceği doğru varyant değeri (ör. ayakkabı numarası) seçilmelidir.
          </Typography>
        </CardContent>
      </Card>

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
        }}
      >
        <Box sx={{ mt: 1 }}>
          <Button
            sx={{ borderRadius: 1, mr: 2 }}
            size="small"
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
            onClick={handleOpenModal}
          >
            Ekle
          </Button>
          {/* <Button
                        sx={{ borderRadius: 1 }}
                        size="small"
                        variant="contained"
                        color="primary"
                        startIcon={<SearchIcon />}
                        onClick={handleSearchToggle}
                    >
                        Filtrele
                    </Button> */}
        </Box>
      </Box>

      {searchVisible && (
        <Box sx={{ mb: 3 }}>
          <TextField
            fullWidth
            label="Kategori Ara"
            variant="outlined"
            size="small"
            value={searchTerm}
            onChange={handleSearchChange}
          />
        </Box>
      )}

      <TableContainer
        sx={{
          maxHeight: 670,
          maxWidth: "100%",
          p: 3,
          background: "white",
          borderRadius: 1,
          boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.2)",
        }}
      >
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>Kategori Adı</TableCell>
              <TableCell>Pazaryeri Varyant Adı</TableCell>
              <TableCell>Pazaryeri</TableCell>
              <TableCell>Varyant adı </TableCell>
              <TableCell sx={{ width: 350 }}>İşlemler</TableCell>
            </TableRow>
          </TableHead>
          {filteredData?.length > 0 ? (
            <TableBody>
              {filteredData.map((item, index) => (
                <TableRow key={index} sx={{ background: "white" }}>
                  <TableCell>{item?.category?.name}</TableCell>
                  <TableCell>{item?.variantName}</TableCell>
                  <TableCell>
                    {item?.marketPlaceName || item?.ecommercePlace?.name}
                  </TableCell>
                  <TableCell>{item.pcVariantName}</TableCell>
                  <TableCell>
                    <Button
                      sx={{
                        borderRadius: 1,
                      }}
                      size="small"
                      variant="contained"
                      color="primary"
                      onClick={() => deleteCategoryVariant(item.id)}
                    >
                      Sil
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          ) : (
            <TableBody>
              <TableRow>
                <TableCell colSpan={4} align="center">
                  Henüz kategori varyantı eşleşirilmedi
                </TableCell>
              </TableRow>
            </TableBody>
          )}
        </Table>
      </TableContainer>
      <CategoryVariantAdd open={openModal} handleClose={handleCloseModal} />
    </Box>
  );
};
